import { useState, useEffect } from "react";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "http://localhost:7071/api";

export function useDataExchangeManifest({ includeExportOnly = false } = {}) {
  const [fieldGroups, setFieldGroups] = useState([]);
  const [keyFields, setKeyFields] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    const qs = includeExportOnly ? "?include_export_only=true" : "";
    fetch(`${API_BASE_URL}/data_exchange_manifest${qs}`)
      .then(async res => {
        if (!res.ok) throw new Error((await res.json()).error || "Manifest fetch failed");
        return res.json();
      })
      .then(data => {
        if (cancelled) return;
        setFieldGroups(data.field_groups || []);
        setKeyFields(data.key_fields || []);
        setError(null);
      })
      .catch(err => {
        if (cancelled) return;
        console.error("useDataExchangeManifest:", err);
        setFieldGroups([]);
        setKeyFields([]);
        setError(err.message);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => { cancelled = true; };
  }, [includeExportOnly]);

  return { fieldGroups, keyFields, loading, error };
}
